import { render, staticRenderFns } from "./ActionsOld.vue?vue&type=template&id=a084359c&scoped=true&"
import script from "./ActionsOld.vue?vue&type=script&lang=js&"
export * from "./ActionsOld.vue?vue&type=script&lang=js&"
import style0 from "./ActionsOld.vue?vue&type=style&index=0&id=a084359c&lang=scss&scoped=true&"
import style1 from "./ActionsOld.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a084359c",
  null
  
)

export default component.exports